import _remove from 'lodash.remove';
/**
 * AppContext is a simple plain array of string values
 */
type AppContext = string[];

/*
 *  State helper, that will set a value in AppContext if it doesn't exist already
 *  @context {AppContext} Current array of context values
 *  @value {string} New value to be added to the AppContext
 */
export const setAppContext = (
  context: AppContext,
  value: string
): AppContext => {
  const entryExists = context.findIndex((ctx) => ctx === value) > -1;
  return !entryExists ? [...context].concat(value) : context;
};

/*
 *  State helper, that will remove a value from AppContext
 */
export const removeAppContext = (
  context: AppContext,
  value: string
): AppContext => {
  return _remove(context, (current) => {
    return current !== value;
  });
};
